import "./bootstrap";

import Vue from "vue";

import "../errors";

import VueRouter from "vue-router";

import "vue-select/dist/vue-select.css";

import TranslatorPlugin from "../plugins/translator";

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(VueRouter);
Vue.use(TranslatorPlugin);

Vue.prototype.$events = new Vue();

import GlobalMixin from "../mixins/Global";
Vue.mixin(GlobalMixin);

Vue.component(
  "pulse-loader",
  require("vue-spinner/src/PulseLoader.vue").default
);
Vue.component("currency", require("../components/Currency.vue").default);
Vue.component("price-diff", require("./components/PriceDiff.vue").default);
Vue.component("spinner", require("../components/Spinner.vue").default);

Vue.component(
  "app-configurator",
  require("./components/AppConfigurator.vue").default
);

Vue.filter("chunk", require("../filters/chunk").default);

const routes = [
  { path: "/", component: require("./components/BrandSelect.vue").default },
  {
    path: "/brands/:id",
    component: require("./components/CatalogModelList.vue").default,
    name: "brand",
  },
  {
    path: "/models/:id",
    component: require("./components/ConfigurationCreate.vue").default,
    name: "model",
  },
  {
    path: "/configurations",
    component: require("./components/ConfigurationList.vue").default,
    name: "configurations",
  },
  {
    path: "/configurations/:id",
    component: require("./components/ConfigurationDetail.vue").default,
    name: "configuration",
  },
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  base: window.location.pathname.split("/")[1],
  routes: routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (window.parent) {
      window.parent.postMessage(
        {
          type: "routeChange",
        },
        "*"
      );
    }

    return savedPosition;
  },
});

const app = new Vue({
  el: "app-configurator",
  router: router,
});
